exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component.dataset.focus {\r\n  box-shadow: 0px 4px 6px #ccc;\r\n}\r\n.component.dataset .header {\r\n  background: steelblue;\r\n  color: #fff;\r\n}\r\n.component.dataset .header .delete {\r\n  color: #fff;\r\n}\r\n\r\n.component.dataset .body {\r\n  min-width: 100px;\r\n  max-width: 350px;\r\n}\r\n\r\n.fields {\r\n  margin: 0;\r\n  padding: 0.75rem 0 0.25rem;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n}", ""]);

// exports
